import { Strategy } from 'utility-ts-strategy';
import { TransferConfiguration } from './../config/transfer_configuration';
import { ITransferCoursesDatasource } from './../datasources/transfer_courses_datasource';

angular
  .module('capability-ng-transfer')
  .run(
    (
      ngTransferCoursesDatasource: ITransferCoursesDatasource,
      ngTransferConfiguration: TransferConfiguration,
      log: any
    ) => {
      const successMessageStrategy = new Strategy<Record<string, any>>({
        anonymous: {
          title: `Congratulations, you've added your first course!`,
          content: `<a tabindex="0" href="#!/my/account/">Create a profile</a> to automatically save your work.`,
          dismissOnTimeout: false,
          dismissButton: true,
          timeout: 99000
        },
        nonAnonymous: {
          content: `Congratulations, you've added your first course!`,
          timeout: 10000,
          dismissOnTimeout: true,
          dismissButton: true
        }
      });

      ngTransferCoursesDatasource.$prePut = (v) => {
        if (!ngTransferCoursesDatasource.model.hasFirstCourseBeenSelected) {
          ngTransferConfiguration.isAnonymous()
            ? log.user.success(successMessageStrategy['anonymous'])
            : log.user.success(successMessageStrategy['nonAnonymous']);
        }
        return v;
      };

      ngTransferCoursesDatasource.$preWrite = (v) => {
        ngTransferCoursesDatasource.model.hasFirstCourseBeenSelected = true;
        return v;
      };

      ngTransferCoursesDatasource.$postWrite = (v) => {
        if (!(ngTransferCoursesDatasource.size() > 0)) {
          ngTransferCoursesDatasource.model.hasFirstCourseBeenSelected = false;
        }
        return v;
      };

      ngTransferCoursesDatasource.$postPut = (v) => {
        ngTransferCoursesDatasource.model.hasFirstCourseBeenSelected = true;
        return v;
      };

      ngTransferCoursesDatasource.$postClear = () => {
        ngTransferCoursesDatasource.model.hasFirstCourseBeenSelected = false;
        return ngTransferCoursesDatasource;
      };
    }
  );



// WEBPACK FOOTER //
// ./app/lib/transfer/notifications/first_course_added_notification.ts